import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import SaveAndCloseButtons from './SaveAndCloseButtons';

const InsuredInfoPanel = ({ title, children, onSave = () => {}, onClose = () => {}, isDisabled = false }) => (
  <VStack alignItems="stretch" pb="30px" pt="50px" px="40px" width="100%">
    <Text mb={3} textStyle="bodyXxl500" textTransform="capitalize">{title}</Text>
    {children}
    <SaveAndCloseButtons isDisabled={isDisabled} onClose={onClose} onSave={onSave} />
  </VStack>
);

InsuredInfoPanel.propTypes = {
  title: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  isDisabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default InsuredInfoPanel;
